import { render } from "./editCompany.vue?vue&type=template&id=62ee9745&scoped=true"
import script from "./editCompany.vue?vue&type=script&lang=js"
export * from "./editCompany.vue?vue&type=script&lang=js"

import "./editCompany.vue?vue&type=style&index=0&id=62ee9745&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62ee9745"]])

export default __exports__